'use client';

import { useEffect, useRef } from 'react';
import type { ProductType } from '@roomtreatment/av-catalog';
import { EVENTS, track } from '@/lib/analytics';

/** Fires `gear_page_viewed` once per product page view. Renders nothing. */
export default function GearPageViewed({ productId, type }: { productId: string; type: ProductType }) {
  // Guards React's development double-invoke; a client-side navigation to
  // another product changes `productId` and counts as a new view.
  const sent = useRef<string | null>(null);
  useEffect(() => {
    if (sent.current === productId) return;
    sent.current = productId;
    track(EVENTS.gear_page_viewed, { product_id: productId, type });
  }, [productId, type]);
  return null;
}
